import { render, staticRenderFns } from "./headerBox.vue?vue&type=template&id=511a0577&scoped=true&"
import script from "./headerBox.vue?vue&type=script&lang=js&"
export * from "./headerBox.vue?vue&type=script&lang=js&"
import style0 from "./headerBox.vue?vue&type=style&index=0&id=511a0577&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511a0577",
  null
  
)

export default component.exports